import { render, staticRenderFns } from "./Allergens.vue?vue&type=template&id=3c78deda&"
import script from "./Allergens.vue?vue&type=script&lang=js&"
export * from "./Allergens.vue?vue&type=script&lang=js&"
import style0 from "./Allergens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports